var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendingError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.159,
    height: 20,
    viewBox: "0 0 22.159 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sending_Error",
    "data-name": "Sending Error",
    transform: "translate(-1177.069 -959.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_547",
    "data-name": "Caminho 547",
    d: "M20.057,22H3.943a3.023,3.023,0,0,1-2.618-4.534L9.382,3.511a3.023,3.023,0,0,1,5.235,0l8.057,13.955A3.023,3.023,0,0,1,20.057,22Z",
    transform: "translate(1176.148 957.5)",
    fill: "#ffd7ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_181",
    "data-name": "Elipse 181",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1187.148 973.5)",
    fill: "#ef4411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    "data-name": "Caminho 548",
    d: "M12,14a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v4A1,1,0,0,1,12,14Z",
    transform: "translate(1176.148 957.5)",
    fill: "#ef4411"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendingError);
export default __webpack_public_path__ + "static/media/Sending Error.a9f081a3.svg";
export { ForwardRef as ReactComponent };